﻿import { Utility } from "../Utility.js";
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';

export { Shortcuts };

/**
 * Class Shortcuts do mapa
 */
const Shortcuts = function () {
    // Define this
    var myShortcuts = this;

    // -- begin private variable ------------------------------------------------------------------

    // Utility
    this._utility = new Utility();

    // MapSgs
    this._mapSgs = null;

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Shortcuts init 
     */
    this.Init = function (mapSgs) {
        // 
        this.columnDefArrayShortcuts = [];

        myShortcuts._mapSgs = mapSgs;

        // Shortcut Id
        this._objDef = {
            'data': 'shortcutId',
            'title': ' ',
            'name': 'shortcutId',
            'label': 'shortcutId',
            'type': 'readonly',
            'orderable': false,
            'visible': false,
            'width': '0px'
        };
        this.columnDefArrayShortcuts.push(this._objDef);

        // Shortcut Type
        this._objDef = {
            'data': 'shortcutType',
            'title': '',
            'name': 'shortcutType',
            'label': 'shortcutType',
            'type': 'readonly',
            'orderable': false,
            'visible': false,
            'width': '0px'
        };
        this.columnDefArrayShortcuts.push(this._objDef);

        // Shortcut name
        this._objDef = {
            'data': 'shortcutName',
            'title': ' ',
            'name': 'shortcutName',
            'label': 'shortcutName',
            'type': 'readonly',
            'orderable': false,
            'width': '200px'
        };
        this.columnDefArrayShortcuts.push(this._objDef);

        // Shortcut description
        this._objDef = {
            'data': 'shortcutDescription',
            'title': '',
            'name': 'shortcutDescription',
            'label': 'shortcutDescription',
            'type': 'readonly',
            'orderable': false,
            'visible': false,
            'width': '0px'
        };
        this.columnDefArrayShortcuts.push(this._objDef);

        // Shortcut actions - goto
        this._objDef = {
            'data': 'shortcutActionGoto',
            'title': ' ',
            'name': 'shortcutActionGoto',
            'label': 'shortcutActionGoto',
            'type': 'readonly',
            'orderable': false,
            'width': '20px'
        };
        this.columnDefArrayShortcuts.push(this._objDef);

        // Shortcut actions - edit
        this._objDef = {
            'data': 'shortcutActionEdit',
            'title': ' ',
            'name': 'shortcutActionEdit',
            'label': 'shortcutActionEdit',
            'type': 'readonly',
            'orderable': false,
            'width': '20px'
        };
        this.columnDefArrayShortcuts.push(this._objDef);

        // Shortcut actions - delete
        this._objDef = {
            'data': 'shortcutActionDelete',
            'title': ' ',
            'name': 'shortcutActionDelete',
            'label': 'shortcutActionDelete',
            'type': 'readonly',
            'orderable': false,
            'width': '20px'
        };
        this.columnDefArrayShortcuts.push(this._objDef);

        // Shortcut srs_SRID
        this._objDef = {
            'data': 'shortcutSRID',
            'title': ' ',
            'name': 'shortcutSRID',
            'label': 'shortcutSRID',
            'type': 'readonly',
            'orderable': false,
            'visible': false,
            'width': '0px'
        };
        this.columnDefArrayShortcuts.push(this._objDef);

        // Shortcut zoom level
        this._objDef = {
            'data': 'shortcutZoom',
            'title': ' ',
            'name': 'shortcutZoom',
            'label': 'shortcutZoom',
            'type': 'readonly',
            'orderable': false,
            'visible': false,
            'width': '0px'
        };
        this.columnDefArrayShortcuts.push(this._objDef);

        // Shortcut resolution
        this._objDef = {
            'data': 'shortcutResolution',
            'title': ' ',
            'name': 'shortcutResolution',
            'label': 'shortcutResolution',
            'type': 'readonly',
            'orderable': false,
            'visible': false,
            'width': '0px'
        };
        this.columnDefArrayShortcuts.push(this._objDef);

        // Shortcut X_Center
        this._objDef = {
            'data': 'shortcutXCenter',
            'title': ' ',
            'name': 'shortcutXCenter',
            'label': 'shortcutXCenter',
            'type': 'readonly',
            'orderable': false,
            'visible': false,
            'width': '0px'
        };
        this.columnDefArrayShortcuts.push(this._objDef);

        // Shortcut Y_Center
        this._objDef = {
            'data': 'shortcutYCenter',
            'title': ' ',
            'name': 'shortcutYCenter',
            'label': 'shortcutYCenter',
            'type': 'readonly',
            'orderable': false,
            'visible': false,
            'width': '0px'
        };
        this.columnDefArrayShortcuts.push(this._objDef);

        // Shortcut Bounding Box
        this._objDef = {
            'data': 'shortcutBBox',
            'title': ' ',
            'name': 'shortcutBBox',
            'label': 'shortcutBBox',
            'type': 'readonly',
            'orderable': false,
            'visible': false,
            'width': '0px'
        };
        this.columnDefArrayShortcuts.push(this._objDef);

        // Shortcut Rotation
        this._objDef = {
            'data': 'shortcutRotation',
            'title': ' ',
            'name': 'shortcutRotation',
            'label': 'shortcutRotation',
            'type': 'readonly',
            'orderable': false,
            'visible': false,
            'width': '0px'
        };
        this.columnDefArrayShortcuts.push(this._objDef);
  
        // -- Table definition --
        this.datatableShortcutsPublic = $('#offcanvas-shortcuts-public-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum local criado'
            },
            "fixedHeader": true,
            "info": false,
            "scrollY": $('#offcanvas-shortcuts-public-table').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": true,
            "columns": this.columnDefArrayShortcuts,
            "initComplete": function (settings, json) {
                $('#offcanvas-shortcuts-public-table_scroll').height($('#offcanvas-shortcuts-public-table').css('max-height').replace('px', '') - 20);
            },
            "select": false,
            "name": "search_shortcuts_result",
            "rowId": 'id_evento_vli'
        });

        // -- Table definition --
        this.datatableShortcutsPrivate = $('#offcanvas-shortcuts-private-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum local criado'
            },
            "fixedHeader": true,
            "info": false,
            "scrollY": $('#offcanvas-shortcuts-private-table').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": true,
            "columns": this.columnDefArrayShortcuts,
            "initComplete": function (settings, json) {
                $('#offcanvas-shortcuts-private-table_scroll').height($('#offcanvas-shortcuts-private-table').css('max-height').replace('px', '') - 20);
            },
            "select": false,
            "name": "search_shortcuts_result",
            "rowId": 'id_evento_vli'
        });

        // -- Table definition --
        this.datatableShortcutsPublicPois = $('#offcanvas-shortcuts-public-pois-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum local criado'
            },
            "fixedHeader": true,
            "info": false,
            "scrollY": $('#offcanvas-shortcuts-public-table').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": true,
            "columns": this.columnDefArrayShortcuts,
            "initComplete": function (settings, json) {
                $('#offcanvas-shortcuts-public-table_scroll').height($('#offcanvas-shortcuts-public-table').css('max-height').replace('px', '') - 20);
            },
            "select": false,
            "name": "search_shortcuts_result",
            "rowId": 'id_evento_vli'
        });

        // -- Table definition --
        this.datatableShortcutsPrivatePois = $('#offcanvas-shortcuts-private-pois-table').DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhum local criado'
            },
            "fixedHeader": true,
            "info": false,
            "scrollY": $('#offcanvas-shortcuts-private-table').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": true,
            "columns": this.columnDefArrayShortcuts,
            "initComplete": function (settings, json) {
                $('#offcanvas-shortcuts-private-table_scroll').height($('#offcanvas-shortcuts-private-table').css('max-height').replace('px', '') - 20);
            },
            "select": false,
            "name": "search_shortcuts_result",
            "rowId": 'id_evento_vli'
        });

        // set column icon positions on datatables
        this.goToColumn = 4;
        this.editColumn = 5;
        this.deleteColumn = 6;

        // load shortcuts
        myShortcuts.LoadShortcuts();

        // Fill shortcut types combo - modal window
        $('#shortcut-map_shortcut-type').append($('<option value="' + 1 + '">' + 'Privado' + '</option>'));
        $('#shortcut-map_shortcut-type').append($('<option value="' + 2 + '">' + 'Público' + '</option>'));
        $('#shortcut-map_shortcut-type').selectpicker('refresh');

        // init public and private tabs
        $('.nav-tabs-public a').click(function (e) {
            e.preventDefault()
            $(this).tab('show')
        })
        $('.nav-tabs-private a').click(function (e) {
            e.preventDefault()
            $(this).tab('show')
        })
    };

    /**
     * Load Public and Private Shortcuts (for user)
     * */
    this.LoadShortcuts = function () {
        // 
        $.ajax({
            type: 'GET',
            url: '/rest/app/Shortcut/GetAllShortcut',
            xhrFields: {
                withCredentials: true
            },
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro de carregamento dos locais guardados");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            var tmpShortcutObj;
                            // clear all datatables
                            myShortcuts.datatableShortcutsPublic.clear().draw();
                            myShortcuts.datatableShortcutsPublicPois.clear().draw();
                            myShortcuts.datatableShortcutsPrivate.clear().draw();
                            myShortcuts.datatableShortcutsPrivatePois.clear().draw();
                            // public shortcuts - views and pois
                            for (let i = 0; i < data.result.list_map_shortcut_public.length; i++) {
                                tmpShortcutObj = {
                                    shortcutId: data.result.list_map_shortcut_public[i].id,
                                    shortcutType: data.result.list_map_shortcut_public[i].cod_type,
                                    shortcutName: data.result.list_map_shortcut_public[i].name,
                                    shortcutDescription: data.result.list_map_shortcut_public[i].description,
                                    shortcutSRID: data.result.list_map_shortcut_public[i].srs_srid,
                                    shortcutZoom: data.result.list_map_shortcut_public[i].zoom_level,
                                    shortcutResolution: data.result.list_map_shortcut_public[i].resolution,
                                    shortcutXCenter: data.result.list_map_shortcut_public[i].x_center,
                                    shortcutYCenter: data.result.list_map_shortcut_public[i].y_center,
                                    shortcutBBox: data.result.list_map_shortcut_public[i].bounding_box,
                                    shortcutRotation: data.result.list_map_shortcut_public[i].rotation,
                                    shortcutActionGoto: '<a class="btn btn-flat text-primary"><i class="fa fa-map-marker"></i></a>',
                                    shortcutActionEdit: '<a class="btn btn-flat text-primary"><i class="fa fa-edit"></i></a>',
                                    shortcutActionDelete: '<a class="btn btn-flat text-primary"><i class="fa fa-trash" ></i></a>'
                                };
                                if (tmpShortcutObj.shortcutType === "PUBLIC_VIEW") {
                                    myShortcuts.datatableShortcutsPublic.row.add(tmpShortcutObj);
                                }
                                else if (tmpShortcutObj.shortcutType === "PUBLIC_POI") {
                                    myShortcuts.datatableShortcutsPublicPois.row.add(tmpShortcutObj);
                                }
                            }
                            // private shortcuts - views and poiss
                            for (let i = 0; i < data.result.list_map_shortcut_private.length; i++) {
                                // only if id_user=userID
                                if (data.result.list_map_shortcut_private[i].id_user === abp.session.userId) {    
                                    tmpShortcutObj = {
                                        shortcutId: data.result.list_map_shortcut_private[i].id,
                                        shortcutType: data.result.list_map_shortcut_private[i].cod_type,
                                        shortcutName: data.result.list_map_shortcut_private[i].name,
                                        shortcutDescription: data.result.list_map_shortcut_private[i].description,
                                        shortcutSRID: data.result.list_map_shortcut_private[i].srs_srid,
                                        shortcutZoom: data.result.list_map_shortcut_private[i].zoom_level,
                                        shortcutResolution: data.result.list_map_shortcut_private[i].resolution,
                                        shortcutXCenter: data.result.list_map_shortcut_private[i].x_center,
                                        shortcutYCenter: data.result.list_map_shortcut_private[i].y_center,
                                        shortcutBBox: data.result.list_map_shortcut_private[i].bounding_box,
                                        shortcutRotation: data.result.list_map_shortcut_private[i].rotation,
                                        shortcutActionGoto: '<a class="btn btn-flat text-primary"><i class="fa fa-map-marker"></i></a>',
                                        shortcutActionEdit: '<a class="btn btn-flat text-primary"><i class="fa fa-edit"></i></a>',
                                        shortcutActionDelete: '<a class="btn btn-flat text-primary"><i class="fa fa-trash" ></i></a>'
                                    }
                                    if (tmpShortcutObj.shortcutType === "PRIVATE_VIEW") {
                                        myShortcuts.datatableShortcutsPrivate.row.add(tmpShortcutObj);
                                    }
                                    else if (tmpShortcutObj.shortcutType === "PRIVATE_POI") {
                                        myShortcuts.datatableShortcutsPrivatePois.row.add(tmpShortcutObj);
                                    }
                                }
                            }
                            // draw all datatables
                            myShortcuts.datatableShortcutsPublic.draw();
                            myShortcuts.datatableShortcutsPublicPois.draw();
                            myShortcuts.datatableShortcutsPrivate.draw();
                            myShortcuts.datatableShortcutsPrivatePois.draw();

                           
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro de carregamento dos locais guardados");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento dos locais guardados");
            }
        });
        // sets height for both datatables
        //$('.dataTables_scrollBody').css({ 'height': '300px' });
    };

    /**
    * Save or Update Shortcut
    * */
    this.SaveShortcut = function () {
        var _shortcutCreationForm = $('#form-save-shortcut').serializeJSON();

        // Get userId 
        _shortcutCreationForm.id_user = parseInt(abp.session.userId);

        // Get id from form (if null = new shortcut)
        _shortcutCreationForm.id = parseInt(_shortcutCreationForm.id);

        // User is changing view and zoom level
        // OR
        // User is creating a new shortcut ( checkbox is not visible ;) ) 
        if ($('#check-edit-geom')[0].checked || $('#check-edit-geom-label')[0].style.display === 'none') {
            _shortcutCreationForm.srs_srid = (app.sgs.Map.map.getView().getProjection().code_).replace(/^\D+/g, '');
            _shortcutCreationForm.zoom_level = app.sgs.Map.map.getView().getZoom();
            _shortcutCreationForm.resolution = app.sgs.Map.map.getView().getResolution();
            // check 
            // view or POI
            if (_shortcutCreationForm.cod_type === 'PRIVATE_VIEW' || _shortcutCreationForm.cod_type === 'PUBLIC_VIEW') { 
                _shortcutCreationForm.x_center = app.sgs.Map.map.getView().getCenter()[0];
                _shortcutCreationForm.y_center = app.sgs.Map.map.getView().getCenter()[1];
            }
            _shortcutCreationForm.bounding_box = app.sgs.Map.map.getView().calculateExtent().toString();
            _shortcutCreationForm.rotation = app.sgs.Map.map.getView().getRotation();
        }
        // User is not changing view/zoom/etc ; only name/description
        else if (!$('#check-edit-geom')[0].checked) {
            _shortcutCreationForm.srs_srid = $('#modal-srs_srid').val();
            _shortcutCreationForm.resolution = $('#modal-resolution').val();
            _shortcutCreationForm.x_center = $('#modal-x_center').val();
            _shortcutCreationForm.y_center = $('#modal-y_center').val();
            _shortcutCreationForm.bounding_box = $('#modal-bounding_box').val();
            _shortcutCreationForm.rotation = $('#modal-rotation').val();
        }

        // set Private or Public type
        if ($('#shortcut-map_shortcut-type')[0].options.selectedIndex === 1) { // index 1 -> private
            if (_shortcutCreationForm.cod_type.includes('VIEW')) {
                _shortcutCreationForm.cod_type = 'PRIVATE_VIEW';
            }
            else {
                _shortcutCreationForm.cod_type = 'PRIVATE_POI';
            }
        }
        else { // public
            if (_shortcutCreationForm.cod_type.includes('VIEW')) {
                _shortcutCreationForm.cod_type = 'PUBLIC_VIEW';
            }
            else {
                _shortcutCreationForm.cod_type = 'PUBLIC_POI';
            }
        }

        // Remove datatable-row-id from object
        delete _shortcutCreationForm["datatable-row-id"];
        
        $.ajax({
            type: 'POST',
            url: '/rest/app/Shortcut/SaveShortcut',
            xhrFields: {
                withCredentials: true
            },
            data: JSON.stringify(_shortcutCreationForm),
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na gravação do local");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                                myShortcuts.LoadShortcuts();
                            //}
                            toastr["success"]("Local gravado com sucesso");
                            break;
                        case 'NOT_FOUND':
                            toastr["warning"]("Nenhum local encontrado");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na gravação do local");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na gravação do local");
            }
        });
    };


    // -- end public method -----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    // click on Reload Shortcuts button
    $('#creation-shortcuts-reload').on('click', function () {
        myShortcuts.LoadShortcuts();
    });

    // click on "Criar Ponto"
    $('#creation-shortcuts-POI-public-submit').on('click', function () {
		// hide offcanvas
        myShortcuts._utility.ShowOpenCanvas3('offcanvas-favs', false);
        // set draw point
        app.DrawPointPOI.setActive(true);
        // set modal vars
        $('#modal-id-shortcut').val("-1");
        $('#modal-datatable-row-id').val("");
        $('#modal-local-shortcut').val("");
        $('#modal-description-shortcut').val("");
        // new shortcut POI is Private by default
        $('#modal-cod_type-shortcut').val("PRIVATE_POI");
        $('#header-modal-shortcut-label').text('Novo ponto');
        // hide Edit Geom Checkbox
        $('#check-edit-geom-label').css({ 'display': 'none' });
        // Clean Shortcut POI
        app.layerDrawPointPOIShow.getSource().clear();
        $('#shortcut-edit-poi').css({ 'visibility': 'hidden' });

        // Desactive interaction
        if(myShortcuts._mapSgs.tooltips)
            myShortcuts._mapSgs.map.un('singleclick', myShortcuts._mapSgs.tooltips.BuildInfoTooltips);
    });

    // click on "Criar Vista"
    $('#creation-shortcuts-public-submit').on('click', function () {
        // hide offcanvas
        myShortcuts._utility.ShowOpenCanvas3('offcanvas-favs', false);
        // set modal vars
        $('#modal-id-shortcut').val("-1");
        $('#modal-datatable-row-id').val("");
        $('#modal-local-shortcut').val("");
        $('#modal-description-shortcut').val("");
        // new shortcut is Private by default
        $('#modal-cod_type-shortcut').val("PRIVATE_VIEW");
        $('#header-modal-shortcut-label').text('Nova vista');
        // hide Edit Geom Checkbox
        $('#check-edit-geom-label').css({ 'display': 'none' });
        // show modal window
        $('#modal-shortcut').css({ 'display': 'block' });
        $('#shortcut-edit-poi').css({ 'visibility': 'hidden' });

        // Active tooltip
        if(myShortcuts._mapSgs.tooltips)
            myShortcuts._mapSgs.map.on('singleclick', async (e) => { await myShortcuts._mapSgs.tooltips.BuildInfoTooltips(e); });
    });

    // click on modal cancel button - EDIT/NEW Shortcut
    $('#modal-cancel-shortcut').on('click', function () {
        // show offcanvas
        myShortcuts._utility.ShowOpenCanvas3('offcanvas-favs', true);
        // hide modal window
		$('#modal-shortcut').css({ 'display': 'none' });

        // Active tooltip
		if(myShortcuts._mapSgs.tooltips)
            myShortcuts._mapSgs.map.on('singleclick', async (e) => { await myShortcuts._mapSgs.tooltips.BuildInfoTooltips(e); });
    });

    // click on modal cancel button - CONFIRM DELETE
    $('#modal-cancel-ok-cancel').on('click', function () {
        switch ($('#modal-ok-cancel').attr('mode')) {
            case "REMOVE_SHORTCUT":
                myShortcuts._utility.ShowOpenCanvas3('offcanvas-favs', true);
                $('#modal-ok-cancel').css({ 'display': 'none' });
                break;
            default:
            // do nothing
        }
    });

    // click "Gravar" on modal shortcut window
    $('#shortcut-confirm-new').on('click', function () {
        // show offcanvas
        myShortcuts._utility.ShowOpenCanvas3('offcanvas-favs', true);
        // hide modal
        $('#modal-shortcut').css({ 'display': 'none' });
        // save/update public/private shortcut
        myShortcuts.SaveShortcut();
    });

    // click on the datatable PUBLIC
    $('#offcanvas-shortcuts-public-table').on('click', 'td', function () {
        //  Datatable row and column where user clicked
        var rowNumber = myShortcuts.datatableShortcutsPublic.cell(this)[0][0].row;
        var columnNumber = myShortcuts.datatableShortcutsPublic.cell(this)[0][0].column;
        // shortcut ID
        var dataRowId = myShortcuts.datatableShortcutsPublic.row(this).row(rowNumber).data().shortcutId;
        // shortcut Name
        var dataRow = myShortcuts.datatableShortcutsPublic.row(this).row(rowNumber).data().shortcutName;
        // shortcut Description
        var dataRowDescription = myShortcuts.datatableShortcutsPublic.row(this).row(rowNumber).data().shortcutDescription;

        // click on GOTO
        if (columnNumber === myShortcuts.goToColumn) {
            _GoTo('public_view', rowNumber);
        }
        // click on EDIT
        else if (columnNumber === myShortcuts.editColumn) {
            // hide offcanvas
            myShortcuts._utility.ShowOpenCanvas3('offcanvas-favs', false);
            $('#shortcut-map_shortcut-type').css({ 'display': 'none' });
            // load values to modal vars
            $('#modal-datatable-row-id').val(rowNumber);
            $('#modal-id-shortcut').val(dataRowId);
            $('#modal-local-shortcut').val(dataRow);
            $('#modal-description-shortcut').val(dataRowDescription);
            $('#modal-cod_type-shortcut').val("PUBLIC_VIEW");
            $('#modal-srs_srid').val(myShortcuts.datatableShortcutsPublic.row(this).row(rowNumber).data().shortcutSRID);
            $('#modal-zoom_level').val(myShortcuts.datatableShortcutsPublic.row(this).row(rowNumber).data().shortcutZoom);
            $('#modal-resolution').val(myShortcuts.datatableShortcutsPublic.row(this).row(rowNumber).data().shortcutResolution);
            $('#modal-x_center').val(myShortcuts.datatableShortcutsPublic.row(this).row(rowNumber).data().shortcutXCenter);
            $('#modal-y_center').val(myShortcuts.datatableShortcutsPublic.row(this).row(rowNumber).data().shortcutYCenter);
            $('#modal-bounding_box').val(myShortcuts.datatableShortcutsPublic.row(this).row(rowNumber).data().shortcutBBox);
            $('#modal-rotation').val(myShortcuts.datatableShortcutsPublic.row(this).row(rowNumber).data().shortcutRotation);
            // show Edit Geom checkbox
            $('#check-edit-geom-label').css({ 'display': 'block' });
            // change header text
            $('#header-modal-shortcut-label').text('Editar Vista');
            // change combo to "Public"
            $('#shortcut-map_shortcut-type')[0].value = "2";
            $('#shortcut-map_shortcut-type').change();
            // display modal window
            $('#modal-shortcut').css({ 'display': 'block' });
            $('#shortcut-edit-poi').css({ 'visibility': 'hidden' });

            //// Desactive interaction
            //if(myShortcuts._mapSgs.tooltips)
            //    myShortcuts._mapSgs.map.un('singleclick', myShortcuts._mapSgs.tooltips.BuildInfoTooltips);
        }
        // click on DELETE
        else if (columnNumber === myShortcuts.deleteColumn) {
            _Delete('public_view', dataRowId, rowNumber);
        }
    });

    // click on the datatable PRIVATE   
    $('#offcanvas-shortcuts-private-table').on('click', 'td', function () {
        //  Datatable row and column where user clicked
        var rowNumber = myShortcuts.datatableShortcutsPrivate.cell(this)[0][0].row;
        var columnNumber = myShortcuts.datatableShortcutsPrivate.cell(this)[0][0].column;
        // shortcut ID
        var dataRowId = myShortcuts.datatableShortcutsPrivate.row(this).row(rowNumber).data().shortcutId;
        // shortcut Name
        var dataRow = myShortcuts.datatableShortcutsPrivate.row(this).row(rowNumber).data().shortcutName;
        // shortcut Description
        var dataRowDescription = myShortcuts.datatableShortcutsPrivate.row(this).row(rowNumber).data().shortcutDescription;

        // click on GOTO
        if (columnNumber === myShortcuts.goToColumn) {
            _GoTo('private_view', rowNumber);
        }
        // click on EDIT
        else if (columnNumber === myShortcuts.editColumn) {
            // hide offcanvas
            myShortcuts._utility.ShowOpenCanvas3('offcanvas-favs', false);
            $('#shortcut-map_shortcut-type').css({ 'display': 'none' });
            // load values to modal vars
            $('#modal-datatable-row-id').val(rowNumber);
            $('#modal-id-shortcut').val(dataRowId);
            $('#modal-local-shortcut').val(dataRow);
            $('#modal-description-shortcut').val(dataRowDescription);
            $('#modal-cod_type-shortcut').val("PRIVATE_VIEW");
            $('#modal-srs_srid').val(myShortcuts.datatableShortcutsPrivate.row(this).row(rowNumber).data().shortcutSRID);
            $('#modal-zoom_level').val(myShortcuts.datatableShortcutsPrivate.row(this).row(rowNumber).data().shortcutZoom);
            $('#modal-resolution').val(myShortcuts.datatableShortcutsPrivate.row(this).row(rowNumber).data().shortcutResolution);
            $('#modal-x_center').val(myShortcuts.datatableShortcutsPrivate.row(this).row(rowNumber).data().shortcutXCenter);
            $('#modal-y_center').val(myShortcuts.datatableShortcutsPrivate.row(this).row(rowNumber).data().shortcutYCenter);
            $('#modal-bounding_box').val(myShortcuts.datatableShortcutsPrivate.row(this).row(rowNumber).data().shortcutBBox);
            $('#modal-rotation').val(myShortcuts.datatableShortcutsPrivate.row(this).row(rowNumber).data().shortcutRotation);
            // show Edit Geom checkbox
            $('#check-edit-geom-label').css({ 'display': 'block' });
            // change header text
            $('#header-modal-shortcut-label').text('Editar Vista');
            // change combo to "Private"
            $('#shortcut-map_shortcut-type')[0].value = "1";
            $('#shortcut-map_shortcut-type').change();
            // display modal window
            $('#modal-shortcut').css({ 'display': 'block' });
            $('#shortcut-edit-poi').css({ 'visibility': 'hidden' });
        }
        // click on DELETE
        else if (columnNumber === myShortcuts.deleteColumn) {
            _Delete('private_view', dataRowId, rowNumber);
        }
    });

    // click on the datatable PUBLIC POI
    $('#offcanvas-shortcuts-public-pois-table').on('click', 'td', function () {
        //  Datatable row and column where user clicked
        var rowNumber = myShortcuts.datatableShortcutsPublicPois.cell(this)[0][0].row;
        var columnNumber = myShortcuts.datatableShortcutsPublicPois.cell(this)[0][0].column;
        // shortcut ID
        var dataRowId = myShortcuts.datatableShortcutsPublicPois.row(this).row(rowNumber).data().shortcutId;
        // shortcut Name
        var dataRow = myShortcuts.datatableShortcutsPublicPois.row(this).row(rowNumber).data().shortcutName;
        // shortcut Description
        var dataRowDescription = myShortcuts.datatableShortcutsPublicPois.row(this).row(rowNumber).data().shortcutDescription;

        // click on GOTO
        if (columnNumber === myShortcuts.goToColumn) {
            _GoTo('public_poi', rowNumber);
        }
        // click on EDIT
        else if (columnNumber === myShortcuts.editColumn) {
            // hide offcanvas
            myShortcuts._utility.ShowOpenCanvas3('offcanvas-favs', false);
            $('#shortcut-map_shortcut-type').css({ 'display': 'none' });
            // load values to modal vars
            $('#modal-datatable-row-id').val(rowNumber);
            $('#modal-id-shortcut').val(dataRowId);
            $('#modal-local-shortcut').val(dataRow);
            $('#modal-description-shortcut').val(dataRowDescription);
            $('#modal-cod_type-shortcut').val("PUBLIC_POI");
            $('#modal-srs_srid').val(myShortcuts.datatableShortcutsPublicPois.row(this).row(rowNumber).data().shortcutSRID);
            $('#modal-zoom_level').val(myShortcuts.datatableShortcutsPublicPois.row(this).row(rowNumber).data().shortcutZoom);
            $('#modal-resolution').val(myShortcuts.datatableShortcutsPublicPois.row(this).row(rowNumber).data().shortcutResolution);
            $('#modal-x_center').val(myShortcuts.datatableShortcutsPublicPois.row(this).row(rowNumber).data().shortcutXCenter);
            $('#modal-y_center').val(myShortcuts.datatableShortcutsPublicPois.row(this).row(rowNumber).data().shortcutYCenter);
            $('#modal-bounding_box').val(myShortcuts.datatableShortcutsPublicPois.row(this).row(rowNumber).data().shortcutBBox);
            $('#modal-rotation').val(myShortcuts.datatableShortcutsPublicPois.row(this).row(rowNumber).data().shortcutRotation);
            // show Edit Geom checkbox
            $('#check-edit-geom-label').css({ 'display': 'block' });
            // change header text
            $('#header-modal-shortcut-label').text('Editar Ponto');
            // change combo to "Public"
            $('#shortcut-map_shortcut-type')[0].value = "2";
            $('#shortcut-map_shortcut-type').change();
            // display modal window
            $('#modal-shortcut').css({ 'display': 'block' });
            $('#shortcut-edit-poi').css({ 'visibility': 'initial' });
        }
        // click on DELETE
        else if (columnNumber === myShortcuts.deleteColumn) {
            _Delete('public_poi', dataRowId, rowNumber);
        }
    });

    // click on the datatable PRIVATE POI   
    $('#offcanvas-shortcuts-private-pois-table').on('click', 'td', function () {
        //  Datatable row and column where user clicked
        var rowNumber = myShortcuts.datatableShortcutsPrivatePois.cell(this)[0][0].row;
        var columnNumber = myShortcuts.datatableShortcutsPrivatePois.cell(this)[0][0].column;
        // shortcut ID
        var dataRowId = myShortcuts.datatableShortcutsPrivatePois.row(this).row(rowNumber).data().shortcutId;
        // shortcut Name
        var dataRow = myShortcuts.datatableShortcutsPrivatePois.row(this).row(rowNumber).data().shortcutName;
        // shortcut Description
        var dataRowDescription = myShortcuts.datatableShortcutsPrivatePois.row(this).row(rowNumber).data().shortcutDescription;

        // click on GOTO
        if (columnNumber === myShortcuts.goToColumn) {
            _GoTo('private_poi', rowNumber);
        }
        // click on EDIT
        else if (columnNumber === myShortcuts.editColumn) {
            // hide offcanvas
            myShortcuts._utility.ShowOpenCanvas3('offcanvas-favs', false);
            $('#shortcut-map_shortcut-type').css({ 'display': 'none' });
            // load values to modal vars
            $('#modal-datatable-row-id').val(rowNumber);
            $('#modal-id-shortcut').val(dataRowId);
            $('#modal-local-shortcut').val(dataRow);
            $('#modal-description-shortcut').val(dataRowDescription);
            $('#modal-cod_type-shortcut').val("PRIVATE_POI");
            $('#modal-srs_srid').val(myShortcuts.datatableShortcutsPrivatePois.row(this).row(rowNumber).data().shortcutSRID);
            $('#modal-zoom_level').val(myShortcuts.datatableShortcutsPrivatePois.row(this).row(rowNumber).data().shortcutZoom);
            $('#modal-resolution').val(myShortcuts.datatableShortcutsPrivatePois.row(this).row(rowNumber).data().shortcutResolution);
            $('#modal-x_center').val(myShortcuts.datatableShortcutsPrivatePois.row(this).row(rowNumber).data().shortcutXCenter);
            $('#modal-y_center').val(myShortcuts.datatableShortcutsPrivatePois.row(this).row(rowNumber).data().shortcutYCenter);
            $('#modal-bounding_box').val(myShortcuts.datatableShortcutsPrivatePois.row(this).row(rowNumber).data().shortcutBBox);
            $('#modal-rotation').val(myShortcuts.datatableShortcutsPrivatePois.row(this).row(rowNumber).data().shortcutRotation);
            // show Edit Geom checkbox
            $('#check-edit-geom-label').css({ 'display': 'block' });
            // change header text
            $('#header-modal-shortcut-label').text('Editar Ponto');
            // change combo to "Private"
            $('#shortcut-map_shortcut-type')[0].value = "1";
            $('#shortcut-map_shortcut-type').change();
            // display modal window
            $('#modal-shortcut').css({ 'display': 'block' });
            $('#shortcut-edit-poi').css({ 'visibility': 'initial' });
        }
        // click on DELETE
        else if (columnNumber === myShortcuts.deleteColumn) {
            _Delete('private_poi', dataRowId, rowNumber);
        }
    });

    // click on modal DELETE CONFIRM
    $('#modal-confirm-ok-cancel').on('click', function () {
        // If not in mode return
        if ($('#modal-ok-cancel').attr('mode') != 'REMOVE_SHORTCUT')
            return;

        $.ajax({
            type: 'DELETE',
            url: '/rest/app/Shortcut/DeleteShortcut?Id=' + parseInt($('#modal-tmp-row').val()),
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na eliminação do local");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // if public, delete from Datatable Public
                            if ($('#modal-tmp').val() === 'public_view') {
                                myShortcuts.datatableShortcutsPublic.row(this).row($('#modal-tmp-rownumber').val()).remove();
                                myShortcuts.datatableShortcutsPublic.draw();
                            }
                            // if private, delete from Datatable Private
                            else if ($('#modal-tmp').val() === 'private_view') {
                                myShortcuts.datatableShortcutsPrivate.row(this).row($('#modal-tmp-rownumber').val()).remove();
                                myShortcuts.datatableShortcutsPrivate.draw();
                            }
                            // if private POI, delete from Datatable Private POIS
                            else if ($('#modal-tmp').val() === 'private_poi') {
                                myShortcuts.datatableShortcutsPrivatePois.row(this).row($('#modal-tmp-rownumber').val()).remove();
                                myShortcuts.datatableShortcutsPrivatePois.draw();
                            }
                            // if public POI, delete from Datatable public POIS
                            else if ($('#modal-tmp').val() === 'public_poi') {
                                myShortcuts.datatableShortcutsPublicPois.row(this).row($('#modal-tmp-rownumber').val()).remove();
                                myShortcuts.datatableShortcutsPublicPois.draw();
                            }
                            // show offcanvas
                            myShortcuts._utility.ShowOpenCanvas3('offcanvas-favs', true);
                            // hide modal CONFIRM DELETE
                            $('#modal-ok-cancel').css({ 'display': 'none' });
                            app.layerDrawPointPOIShow.getSource().clear();
                            toastr["success"]("Local eliminado");
                            break;
                        case 'NOT_FOUND':
                            toastr["warning"]("Nenhum local encontrado");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na eliminação do local");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na eliminação do local");
            }
        });
    });

    // cancel Criar Ponto/Vista
    $('#modal-cancel-shortcut').on('click', function () {
        app.layerDrawPointPOI.getSource().clear();
    });

    $('#shortcut-edit-poi').on('click', function () {
        $('#modal-shortcut').css({ 'display': 'none' });
        app.layerDrawPointPOIShow.getSource().clear();
        app.DrawPointPOI.setActive(true);
    });


    // bug fix - resize datatable columns on tab show
    $('.nav-tabs a').on('shown.bs.tab', function (event) {
        myShortcuts.datatableShortcutsPrivatePois.columns.adjust().draw();
        myShortcuts.datatableShortcutsPublicPois.columns.adjust().draw();
        myShortcuts.datatableShortcutsPrivate.columns.adjust().draw();
        myShortcuts.datatableShortcutsPublic.columns.adjust().draw();
    });


    // -- end event -------------------------------------------------------------------------------


    // -- begin private functions -----------------------------------------------------------------

    function _Delete(cod_type_text, dataRowId, rowNumber) {
        // Set mode
        $('#modal-ok-cancel').attr('mode', 'REMOVE_SHORTCUT');
        // hide offcanvas
        myShortcuts._utility.ShowOpenCanvas3('offcanvas-favs', false);
        // set vars and display modal CONFIRM DELETE
        $('#header-modal-ok-cancel').text('Tem a certeza?');
        $('#modal-tmp').val(cod_type_text);
        $('#modal-tmp-row').val(dataRowId);
        $('#modal-tmp-rownumber').val(rowNumber);
        $('#modal-ok-cancel').css({ 'display': 'block' });
    }

    function _GoTo(cod_type_text, rowNumber) {
        var X, Y, Zoom;

        app.layerDrawPointPOI.getSource().clear();
        app.layerDrawPointPOIShow.getSource().clear();

        if (cod_type_text === 'public_view') {
            X = myShortcuts.datatableShortcutsPublic.row(this).row(rowNumber).data().shortcutXCenter;
            Y = myShortcuts.datatableShortcutsPublic.row(this).row(rowNumber).data().shortcutYCenter;
            Zoom = myShortcuts.datatableShortcutsPublic.row(this).row(rowNumber).data().shortcutZoom;
        }
        else if (cod_type_text === 'private_view') {
            X = myShortcuts.datatableShortcutsPrivate.row(this).row(rowNumber).data().shortcutXCenter;
            Y = myShortcuts.datatableShortcutsPrivate.row(this).row(rowNumber).data().shortcutYCenter;
            Zoom = myShortcuts.datatableShortcutsPrivate.row(this).row(rowNumber).data().shortcutZoom;
        }
        else if (cod_type_text === 'private_poi') {
            X = myShortcuts.datatableShortcutsPrivatePois.row(this).row(rowNumber).data().shortcutXCenter;
            Y = myShortcuts.datatableShortcutsPrivatePois.row(this).row(rowNumber).data().shortcutYCenter;
            Zoom = myShortcuts.datatableShortcutsPrivatePois.row(this).row(rowNumber).data().shortcutZoom;
            _setMarkerAtXY(X, Y);
        }
        else if (cod_type_text === 'public_poi') {
            X = myShortcuts.datatableShortcutsPublicPois.row(this).row(rowNumber).data().shortcutXCenter;
            Y = myShortcuts.datatableShortcutsPublicPois.row(this).row(rowNumber).data().shortcutYCenter;
            Zoom = myShortcuts.datatableShortcutsPublicPois.row(this).row(rowNumber).data().shortcutZoom;
            _setMarkerAtXY(X, Y);
        }
        // check for null coordinates
        if (!(!X && !Y)) {
            app.sgs.Map.map.getView().animate({
                center: [X, Y],
                zoom: Zoom,
                duration: 1000
            });
        }
    }

    function _setMarkerAtXY(X, Y) {
        let marker = new Feature({
            geometry: new Point([X, Y])
        });
        app.DrawPointPOIShow.setActive(true);
        app.layerDrawPointPOI.getSource().clear();
        app.layerDrawPointPOIShow.getSource().clear();
        app.layerDrawPointPOIShow.getSource().addFeature(marker);
        app.layerDrawPointPOIShow.getSource().getFeatures().push(marker);
    }

    // -- end private functions -------------------------------------------------------------------
};